export enum GoalTreeItemIds {
  Goal = 'goal',
  LifeArea = 'life-area',
  NoLifeArea = 'no-life-area',
}

export type GoalTreeItemBase = {
  indentationLevel: number;
  displayColor?: string | null;
  parentName?: string;
  hasChildren?: boolean;
};

export type GoalItem = {
  type: GoalTreeItemIds.Goal;
} & GoalTreeItemBase &
  import('shared/types/goal').Goal;

export type LifeAreaItem = {
  type: GoalTreeItemIds.LifeArea;
} & GoalTreeItemBase &
  import('shared/types/life-area').LifeArea;

export type NoLifeAreaItem = {
  type: GoalTreeItemIds.NoLifeArea;
  id: GoalTreeItemIds.NoLifeArea;
  name: string;
} & GoalTreeItemBase;

export type GoalTreeItem = GoalItem | LifeAreaItem | NoLifeAreaItem;
